import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './AILiveShowController.css';

const AILiveShowAdmin = () => {
  const baseURL = process.env.REACT_APP_PORTAL_DESTINATION;
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const pollingRef = useRef(null);
  const PROGRESS_CONFIG = {
    startValue: 10,        // progress awal
    maxBeforeFinish: 88,   // berhenti di sini sambil nunggu data
    intervalMs: 1000,       // seberapa sering naik (ms)
    minStep: 2,            // kenaikan minimum
    maxStep: 6             // kenaikan maksimum
  };

  const handleRequest = async (endpoint) => {
    try {
        await axios.get(`https://portal.befa.id/${endpoint}`);

        if (endpoint === 'ailiveshowcomment' || endpoint === 'ailiveshowfinal') {
        setIsLoading(true);
        setProgress(PROGRESS_CONFIG.startValue);
        startPolling();
        }

    } catch (error) {
        console.error(`Request to ${endpoint} failed`, error);
    }
  };

  const startPolling = () => {
    if (pollingRef.current) return;

    pollingRef.current = setInterval(async () => {
        try {
        const res = await axios.get('https://portal.befa.id/getAILiveDB');
        const data = res.data?.data;

        if (data && data.active === 1) {
            setProgress(100);
            setTimeout(() => {
            setIsLoading(false);
            setProgress(0);
            }, 2500);

            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        } catch (err) {
        console.error('Polling error', err);
        }
    }, 1000);
  };

  useEffect(() => {
    if (!isLoading) return;

    const interval = setInterval(() => {
        setProgress(prev => {
        if (prev >= PROGRESS_CONFIG.maxBeforeFinish) {
            return prev; // berhenti & nunggu polling
        }

        const step =
            Math.floor(
            Math.random() *
                (PROGRESS_CONFIG.maxStep - PROGRESS_CONFIG.minStep + 1)
            ) + PROGRESS_CONFIG.minStep;

        return Math.min(
            prev + step,
            PROGRESS_CONFIG.maxBeforeFinish
        );
        });
    }, PROGRESS_CONFIG.intervalMs);

    return () => clearInterval(interval);
  }, [isLoading]);

  return (
    <>
        {isLoading && (
        <div className="controller-loading">
            <div className="controller-loading-box">
            <div className="controller-loading-title">
                AI is generating insights
            </div>

            <div className="controller-loading-bar">
                <div
                className="controller-loading-fill"
                style={{ width: `${progress}%` }}
                />
            </div>

            <div className="controller-loading-text">
                {progress < 100
                ? 'Processing discussion...'
                : 'AI Analysis Ready'}
            </div>
            </div>
        </div>
        )}

        <div className="ailive-container">
        <div className="ailive-layout">
            
            <button
            className="ailive-button banner"
            onClick={() => handleRequest('ailiveshowbanner')}
            >
            Banner
            </button>

            <div className="ailive-bottom-row">
            <button
            className="ailive-button banner"
            onClick={() => handleRequest('ailiveshowclear')}
            >
            Clear Data AI Live Show
            </button>
            </div>

        </div>
        </div>
    </>
  );
};

export default AILiveShowAdmin;
